import { render, staticRenderFns } from "./Scandit.vue?vue&type=template&id=7ecd22b4&scoped=true&"
import script from "./Scandit.vue?vue&type=script&lang=js&"
export * from "./Scandit.vue?vue&type=script&lang=js&"
import style0 from "./Scandit.vue?vue&type=style&index=0&id=7ecd22b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd22b4",
  null
  
)

export default component.exports